//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  props: {
    size: {
      type: String,
      default: 'sm'
    },
    color: {
      type: String,
      default: null
    },
    tooltip: {
      type: String,
      default: ''
    },
    inset: {
      type: Boolean,
      default: false
    }
  }
}

